export const officialDocumentStyles = `
  @page {
    size: A4 portrait;
    margin: 20mm;
  }

  html,
  body {
    background: #ffffff;
    color: #111111;
    font-family: Georgia, "Times New Roman", Times, serif;
  }

  body {
    padding: 0;
  }

  .official-document {
    width: 100%;
    max-width: 170mm;
    margin: 0 auto;
    color: #111111;
  }

  .official-header {
    width: 100%;
    max-width: 136mm;
    margin: 0 auto 5mm;
    display: grid;
    grid-template-columns: 40mm 1fr;
    gap: 8mm;
    align-items: start;
  }

  .official-logo-wrap {
    min-height: 20mm;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .official-logo {
    max-width: 42mm;
    max-height: 20mm;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .official-header-main {
    text-align: left;
  }

  .official-vessel-name {
    margin: 0 0 2mm;
    font-size: 18pt;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: 0.01em;
  }

  .official-title {
    margin: 0;
    font-size: 14pt;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .official-rule {
    border: 0;
    border-top: 0.35mm solid #111111;
    margin: 0 0 5mm;
  }

  .official-meta {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 4mm;
  }

  .official-meta td {
    padding: 1.1mm 3.5mm 1.1mm 0;
    vertical-align: top;
    font-size: 10.5pt;
  }

  .official-meta-label {
    width: 15%;
    font-weight: 600;
    white-space: nowrap;
  }

  .official-meta-value {
    width: 35%;
    white-space: nowrap;
  }

  .official-meta-separator {
    border: 0;
    border-top: 0.2mm solid #c9c9c9;
    margin: 0 0 5.5mm;
  }

  .official-section {
    margin-bottom: 10mm;
    page-break-inside: avoid;
  }

  .official-paragraph {
    margin: 0 0 3mm;
    font-size: 11pt;
    line-height: 1.5;
  }

  .official-emphasis {
    font-weight: 700;
  }

  .official-note {
    margin: 0;
    font-size: 10pt;
    line-height: 1.45;
  }

  .official-box {
    border: 0.25mm solid #111111;
    padding: 4mm 4.5mm;
    margin: 4mm 0;
  }

  .official-chip-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 2.5mm;
    margin-top: 3mm;
  }

  .official-chip {
    border: 0.25mm solid #111111;
    padding: 2mm 3mm;
    font-size: 10pt;
    min-width: 15mm;
    text-align: center;
  }

  .official-signatures {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18mm;
    margin-top: 30mm;
    align-items: start;
    page-break-inside: avoid;
  }

  .official-signature-block {
    display: grid;
    grid-template-rows: auto 14mm;
    width: 100%;
  }

  .official-signature-line {
    border-top: 0.25mm solid #111111;
    width: 100%;
  }

  .official-signature-caption {
    min-height: 14mm;
    padding-top: 2mm;
    font-size: 10pt;
  }

  .official-signature-name {
    margin-top: 3mm;
    font-size: 10.5pt;
    font-weight: 700;
    white-space: nowrap;
  }

  .official-receipt {
    margin: 14mm 0 18mm;
    page-break-inside: avoid;
  }

  .official-receipt-grid {
    display: grid;
    grid-template-columns: 18mm 1fr;
    column-gap: 4mm;
    align-items: end;
    width: 100%;
    margin-bottom: 8mm;
  }

  .official-receipt-row-secondary {
    display: grid;
    grid-template-columns: 18mm minmax(0, 1fr) 14mm minmax(0, 1fr);
    column-gap: 5mm;
    align-items: end;
    width: 100%;
    font-size: 10.5pt;
  }

  .official-receipt-label {
    font-weight: 700;
    white-space: nowrap;
  }

  .official-line {
    display: block;
    width: 100%;
    min-height: 12mm;
    border-bottom: 0.25mm solid #111111;
  }

  .official-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 4mm;
    font-size: 10pt;
  }

  .official-table th,
  .official-table td {
    border: 0.2mm solid #111111;
    padding: 2.3mm 2.5mm;
    vertical-align: top;
  }

  .official-table th {
    font-weight: 700;
    text-align: left;
    background: #f5f5f5;
  }

  .official-check-row {
    display: flex;
    gap: 8mm;
    margin-top: 5mm;
    font-size: 10pt;
  }

  .official-check-item {
    display: inline-flex;
    align-items: center;
    gap: 2mm;
  }

  .official-checkbox {
    width: 4mm;
    height: 4mm;
    border: 0.25mm solid #111111;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 9pt;
    line-height: 1;
  }

  .nowrap {
    white-space: nowrap;
  }

  @media print {
    .official-document,
    .official-header,
    .official-section,
    .official-receipt,
    .official-signatures {
      break-inside: avoid;
    }
  }
`;
